import PropTypes from "prop-types";
import React from "react";

import useProviderDetail from "./hooks/useProviderDetail";
import ProviderDetailContent from "./ProviderDetailContent";

export default function ProviderDetailPage({ providerDetail }) {
  const detailState = useProviderDetail(providerDetail, true);

  return (
    <div className="flex h-full w-full justify-center overflow-auto bg-slate-50 py-6">
      <ProviderDetailContent {...detailState} />
    </div>
  );
}

ProviderDetailPage.propTypes = {
  providerDetail: PropTypes.object,
};
